<kiwi-decision-content class="cell-block-y menuSalesPrices" *ngIf="decision">
    <div class="grid-x grid-margin-x grid-margin-y">
        <div class="cell xsmall-24 large-12">
            <fieldset>
                <legend [i18nKey]="'menu.a.la.carte.dishes'"></legend>

                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.first.courses'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>
                    <tr *ngFor="let firstCourseName of decision.firstCoursesSalesPrices | keys">
                        <td>{{'menu.' + firstCourseName | translate}}</td>
                        <td class="_priceColumn" *ngIf="decision.firstCoursesSalesPrices[firstCourseName].inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.firstCoursesSalesPrices[firstCourseName].salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                [name]="firstCourseName + 'salePriceIncludingTax'"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.firstCoursesSalesPrices[firstCourseName].inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.firstCoursesSalesPrices[firstCourseName].inMenu">
                            <button (click)="toggleInMenu(decision.firstCoursesSalesPrices[firstCourseName])"
                                    class="button _small _iconOnly"
                                    [disabled]="isLastDish(decision.firstCoursesSalesPrices) || decisionsReadonly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.firstCoursesSalesPrices[firstCourseName].inMenu">
                            <button (click)="toggleInMenu(decision.firstCoursesSalesPrices[firstCourseName])"
                                    class="button _small success _iconOnly"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.meat.dishes'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>

                    <tr *ngFor="let meatDishName of decision.meatDishesSalesPrices | keys">
                        <td>{{'menu.' + meatDishName | translate}}</td>
                        <td class="_priceColumn" *ngIf="decision.meatDishesSalesPrices[meatDishName].inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.meatDishesSalesPrices[meatDishName].salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                [name]="meatDishName + 'salePriceIncludingTax'"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.meatDishesSalesPrices[meatDishName].inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.meatDishesSalesPrices[meatDishName].inMenu">
                            <button (click)="toggleInMenu(decision.meatDishesSalesPrices[meatDishName])"
                                    class="button _small _iconOnly"
                                    [disabled]="isLastDish(decision.meatDishesSalesPrices) || decisionsReadonly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.meatDishesSalesPrices[meatDishName].inMenu">
                            <button (click)="toggleInMenu(decision.meatDishesSalesPrices[meatDishName])"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.fish.dishes'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>

                    <tr *ngFor="let fishDishName of decision.fishDishesSalesPrices | keys">
                        <td>{{'menu.' + fishDishName | translate}}</td>
                        <td class="_priceColumn" *ngIf="decision.fishDishesSalesPrices[fishDishName].inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.fishDishesSalesPrices[fishDishName].salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                [name]="fishDishName + 'salePriceIncludingTax'"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.fishDishesSalesPrices[fishDishName].inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.fishDishesSalesPrices[fishDishName].inMenu">
                            <button (click)="toggleInMenu(decision.fishDishesSalesPrices[fishDishName])"
                                    class="button _small _iconOnly"
                                    [disabled]="isLastDish(decision.fishDishesSalesPrices) || decisionsReadonly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.fishDishesSalesPrices[fishDishName].inMenu">
                            <button (click)="toggleInMenu(decision.fishDishesSalesPrices[fishDishName])"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.desserts'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>

                    <tr *ngFor="let dessertName of decision.dessertsSalesPrices | keys">
                        <td>{{'menu.' + dessertName | translate}}</td>
                        <td class="_priceColumn" *ngIf="decision.dessertsSalesPrices[dessertName].inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.dessertsSalesPrices[dessertName].salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                [name]="dessertName + 'salePriceIncludingTax'"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.dessertsSalesPrices[dessertName].inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.dessertsSalesPrices[dessertName].inMenu">
                            <button (click)="toggleInMenu(decision.dessertsSalesPrices[dessertName])"
                                    class="button _small _iconOnly"
                                    [disabled]="isLastDish(decision.dessertsSalesPrices) || decisionsReadonly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.dessertsSalesPrices[dessertName].inMenu">
                            <button (click)="toggleInMenu(decision.dessertsSalesPrices[dessertName])"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.wines'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>

                    <tr *ngFor="let wineName of decision.winesSalesPrices | keys">
                        <td>{{'menu.' + wineName | translate}}</td>
                        <td class="_priceColumn" *ngIf="decision.winesSalesPrices[wineName].inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.winesSalesPrices[wineName].salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                [name]="wineName + 'salePriceIncludingTax'"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.winesSalesPrices[wineName].inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.winesSalesPrices[wineName].inMenu">
                            <button (click)="toggleInMenu(decision.winesSalesPrices[wineName])"
                                    class="button _small _iconOnly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.winesSalesPrices[wineName].inMenu">
                            <button (click)="toggleInMenu(decision.winesSalesPrices[wineName])"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
        </div>

        <div class="cell xsmall-24 large-12">
            <fieldset>
                <legend [i18nKey]="'menu.menus'"></legend>
                <table class="_tableColor">
                    <tbody>
                    <tr class="_titlePartTable">
                        <td [i18nKey]="'menu.menus'"></td>
                        <td class="_priceColumn"[i18nKey]="'decisions.menu.sales.prices.including.taxes'"></td>
                        <td></td>
                    </tr>

                    <tr>
                        <td [i18nKey]="'menu.FIRST_COURSE_MAIN_COURSE'"></td>
                        <td class="_priceColumn" *ngIf="decision.firstCourseMainCourseMenu.inMenu">
                            <kiwi-currency-input
                                [(ngModel)]="decision.firstCourseMainCourseMenu.salePriceIncludingTax"
                                (change)="updateScoreImage()"
                                min="{{decision.minDishSalePrice}}"
                                max="{{decision.maxDishSalePrice}}"
                                name="firstCourseMainCourseMenuSalePriceIncludingTax"
                                [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.firstCourseMainCourseMenu.inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.firstCourseMainCourseMenu.inMenu">
                            <button (click)="toggleInMenu(decision.firstCourseMainCourseMenu)"
                                    class="button _small _iconOnly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.firstCourseMainCourseMenu.inMenu">
                            <button (click)="toggleInMenu(decision.firstCourseMainCourseMenu)"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td [i18nKey]="'menu.MAIN_COURSE_DESSERT'"></td>
                        <td class="_priceColumn" *ngIf="decision.mainCourseDessertMenu.inMenu">
                            <kiwi-currency-input [(ngModel)]="decision.mainCourseDessertMenu.salePriceIncludingTax"
                                                 (change)="updateScoreImage()"
                                                 min="{{decision.minDishSalePrice}}"
                                                 max="{{decision.maxDishSalePrice}}"
                                                 name="mainCourseDessertMenuSalePriceIncludingTax"
                                                 [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.mainCourseDessertMenu.inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.mainCourseDessertMenu.inMenu">
                            <button (click)="toggleInMenu(decision.mainCourseDessertMenu)"
                                    class="button _small _iconOnly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.mainCourseDessertMenu.inMenu">
                            <button (click)="toggleInMenu(decision.mainCourseDessertMenu)"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>

                    <tr>
                        <td [i18nKey]="'menu.FULL_COURSE'"></td>
                        <td class="_priceColumn" *ngIf="decision.fullCourse.inMenu">
                            <kiwi-currency-input [(ngModel)]="decision.fullCourse.salePriceIncludingTax"
                                                 (change)="updateScoreImage()"
                                                 min="{{decision.minDishSalePrice}}"
                                                 max="{{decision.maxDishSalePrice}}"
                                                 name="fullCourseSalePriceIncludingTax"
                                                 [disabled]="decisionsReadonly"></kiwi-currency-input>
                        </td>
                        <td class="_priceColumn" *ngIf="!decision.fullCourse.inMenu"[i18nKey]="'decisions.menu.sales.prices.not.in.menu'"></td>
                        <td class="_menuActions" *ngIf="decision.fullCourse.inMenu">
                            <button (click)="toggleInMenu(decision.fullCourse)"
                                    class="button _small _iconOnly"
                                    [title]="'decisions.menu.sales.prices.remove.from.menu'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.remove.from.menu'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </td>
                        <td class="_menuActions" *ngIf="!decision.fullCourse.inMenu">
                            <button (click)="toggleInMenu(decision.fullCourse)"
                                    class="button _small _iconOnly success"
                                    [title]="'decisions.menu.sales.prices.sell.again'|translate" [i18nKey]="[{target: 'attribute:title', key: 'decisions.menu.sales.prices.sell.again'}]"
                                    [disabled]="decisionsReadonly">
                                <i class="fas fa-plus"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>

            <kiwi-score-image
                class="_horizontalView"
                [imgQualityClass]="imgClass"
                [imgType]="'_menuSalesPrices'"
                [scores]="scores"></kiwi-score-image>
        </div>
    </div>
</kiwi-decision-content>
